import { render, staticRenderFns } from "./CardBind.vue?vue&type=template&id=68b92cc2&scoped=true&"
import script from "./CardBind.vue?vue&type=script&lang=js&"
export * from "./CardBind.vue?vue&type=script&lang=js&"
import style0 from "./CardBind.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardBind.vue?vue&type=style&index=1&id=68b92cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b92cc2",
  null
  
)

component.options.__file = "CardBind.vue"
export default component.exports